<div class="tournament-title">
  <a [routerLink]="tournamentRoute" class="name">{{ tournament.name }}</a>
  <a [routerLink]="tournamentRoute" class="btn-detail">Перейти</a>
</div>
<div class="divisions" *ngIf="!loading && divisions.length > 0">
  <mtg-division-standings
    *ngFor="let division of divisions"
    [tournament]="tournament"
    [division]="division"
    [teams]="teamsByDivision[division.id]"
  ></mtg-division-standings>
</div>

<mtg-tournament-standings
  *ngIf="!loading && divisions.length === 0"
  [tournament]="tournament"
></mtg-tournament-standings>

<div class="loading" *ngIf="loading">
  <mtg-spinner></mtg-spinner>
</div>
